import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[appSmartGridEdit]',
  standalone: true,
})
export class SmartGridEditDirective {
  @Input('appSmartGridEdit') field!: string;
  constructor(public template: TemplateRef<any>) {}
}
